<template>
  <section class="container-fluid image-bg py-6 py-md-8" id="asset-hero">
    <div class="row justify-content-center">
      <div class="col-12 col-md-11 col-xl-8">
        <h1 class="white-text text-md-center mb-3 load-anim" ref="headline">
          Dedicated Asset Management and Consulting Services
        </h1>
        <h2
          class="subhead gold-text text-md-center mb-5 load-anim"
          ref="subhead"
        >
          Focused on Results
        </h2>
      </div>
      <div class="col-12 col-md-10 col-lg-8 col-xl-6">
        <div ref="content" class="load-anim">
          <p>
            CS Capital Advisors provides focused asset management and consulting
            services to investors and operators. Our talented team brings a
            combination of operational and transactional experience managing and
            advising on all aspects of senior housing operations to maximize
            value creation for our relationship clients.
          </p>
          <p>
            Our principals have over 120 years of experience with long-standing
            relationships across the senior housing industry. Our team of
            experienced professionals bring a highly skilled approach to
            financial analysis, underwriting, structuring and oversight of
            investments in senior housing real estate and operations.
          </p>
          <p>
            CSCA’s core mission focusses on helping senior housing investors and
            operators devise and achieve their objectives. Our strategic
            perspective and in-depth analytical approach uniquely positions us
            to guide clients through the investment process and management of
            their healthcare real estate portfolios. Our goal is to provide our
            clients with creative and innovative, “hands-on” solutions to the
            complex problems arising across all aspects of seniors housing
            investments, including:
          </p>
          <div class="row">
            <div class="col-12 col-md-6">
              <ul class="mb-0 mb-md-4">
                <li>Asset, Portfolio &amp; Company-Level Advisory</li>
                <li>
                  Dispositions, Acquisitions &amp; Overall Portfolio
                  Rationalization and Optimization
                </li>
                <li>Debt Financing Transactions</li>
                <li>Valuation &amp; ROI Assessment</li>
                <li>Financial Planning &amp; Analysis</li>
              </ul>
            </div>
            <div class="col-12 col-md-6">
              <ul>
                <li>Corporate &amp; Joint Venture Structuring</li>
                <li>Capital Structure &amp; Liquidity Management</li>
                <li>Project Management</li>
                <li>Capital Allocation and Expenditure Management</li>
                <li>Investor Relations</li>
              </ul>
            </div>
          </div>
          <p>
            Our unwavering commitment to putting our client’s interest first has
            earned us the dedicated trust of leading senior housing operators
            and prominent investors. They draw on our insights and advice and
            see us as an extension of their teams.
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { TimelineLite, Power2 } from "gsap";
export default {
  methods: {
    introAnim() {
      var introAnimEls = [];
      introAnimEls.push(this.$refs.headline);
      introAnimEls.push(this.$refs.subhead);
      introAnimEls.push(this.$refs.content);
      var t1 = new TimelineLite();
      t1.staggerTo(
        introAnimEls,
        1,
        { opacity: 1, transform: "translateY(0)", ease: Power2.easeOut },
        0.3,
        "-=0.2"
      );
    }
  },
  mounted() {
    this.introAnim();
  }
};
</script>

<style lang="scss" scoped>
#asset-hero {
  background-image: url(../assets/asset-bg.jpg);
  p,
  li {
    color: #ffffff;
    font-family: europa, sans-serif;
    @media screen and (max-width: 768px) {
      line-height: 1.625rem;
    }
  }
}
#asset-management-1 {
  background-image: url(../assets/asset-management-2.jpg);
}
</style>
